import { Box, Typography, Chip } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import "./Orders.css";

export default function NoOrdersTodayState() {
  return (
    <Box
      sx={{
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "text.secondary",
      }}
    >
      {/* Icon */}
      <DescriptionOutlinedIcon sx={{ fontSize: 64, color: "#B0B7C3" }} />

      {/* Title */}
      <Typography variant="h6" fontWeight={600} mt={2} color="text.primary">
        No orders yet today
      </Typography>

      {/* Subtitle */}
      <Typography variant="body2" mt={0.5}>
        Orders placed today will appear here automatically.
      </Typography>

      {/* Live Indicator */}
      <Chip
        icon={
          <Box className="pulse-plus">
            <FiberManualRecordIcon
              className="plus"
              sx={{ fontSize: 10, color: "#2E7D32" }}
            />
          </Box>
        }
        label="Live — waiting for new orders"
        size="small"
        sx={{
          mt: 2,
          backgroundColor: "#E8F5E9",
          color: "#2E7D32",
          fontWeight: 500,
        }}
      />
    </Box>
  );
}
